import { OrderDetails_order } from "@saleor/motherOrders/types/OrderDetails";
import {
  DeliveryTypeEnum,
  RemittanceManualAdjustmentStatusEnum,
  SmopUserTypeCode
} from "@saleor/types/globalTypes";
import moment from "moment";
import { defineMessages, useIntl } from "react-intl";

import { GetRemittance_remittance_remittanceLines_order } from "../types/GetRemittance";
import { RemittanceRunnerOrders_remittanceOrders_edges_node } from "../types/RemittanceRunnerOrders";

export const isRunnerRider = (usertype: SmopUserTypeCode) =>
  [SmopUserTypeCode.RIDER, SmopUserTypeCode.RUNNER].includes(usertype);

const messages = defineMessages({
  express: {
    defaultMessage: "Express",
    description: "express"
  },
  expressDelivery: {
    defaultMessage: "Express Delivery",
    description: "express delivery"
  },
  expressLongDistance: {
    defaultMessage: "10km Express Delivery",
    description: "expressLongDistance"
  },
  inStore: {
    defaultMessage: "In Store Pickup",
    description: "in store pickup"
  },
  nationwide: {
    defaultMessage: "Nationwide Delivery",
    description: "nationwide delivery"
  },
  nextDay: {
    defaultMessage: "Standard Delivery",
    description: "standard delivery"
  },
  sameDay: {
    defaultMessage: "Same Day Delivery",
    description: "same day delivery"
  }
});

export const getDeliveryTypeString = (
  delType: DeliveryTypeEnum,
  isComplete: boolean = false
) => {
  const intl = useIntl();
  switch (delType) {
    case DeliveryTypeEnum.EXPRESS:
      return intl.formatMessage(
        isComplete ? messages.expressDelivery : messages.express
      );
    case DeliveryTypeEnum.EXPRESS_LONG_DISTANCE:
      return intl.formatMessage(messages.expressLongDistance);
    case DeliveryTypeEnum.IN_STORE_PICKUP:
      return intl.formatMessage(messages.inStore);
    case DeliveryTypeEnum.NATIONWIDE_DELIVERY:
      return intl.formatMessage(messages.nationwide);
    case DeliveryTypeEnum.NEXT_DAY:
      return intl.formatMessage(messages.nextDay);
    case DeliveryTypeEnum.SAME_DAY:
      return intl.formatMessage(messages.sameDay);
    default:
      return "";
  }
};

export const orderForManualAdjustment = (order: OrderDetails_order) =>
  order?.payments?.length > 0 &&
  order?.payments[0]?.paymentMethodType === "cash" &&
  (order?.shippingMethod.deliveryType === DeliveryTypeEnum.EXPRESS ||
    order?.shippingMethod.deliveryType ===
      DeliveryTypeEnum.EXPRESS_LONG_DISTANCE ||
    order?.shippingMethod.deliveryType === DeliveryTypeEnum.NEXT_DAY ||
    order?.shippingMethod.deliveryType === DeliveryTypeEnum.SAME_DAY);

export const isOrderManuallyAdjusted = (
  order:
    | RemittanceRunnerOrders_remittanceOrders_edges_node
    | GetRemittance_remittance_remittanceLines_order
): boolean =>
  order?.remittanceManualAdjustmentStatus ===
    RemittanceManualAdjustmentStatusEnum.COMPLETED ||
  order?.remittanceManualAdjustmentAmount !== 0;

export const getOrderManuallyAdjustedAmount = (
  order:
    | RemittanceRunnerOrders_remittanceOrders_edges_node
    | GetRemittance_remittance_remittanceLines_order
): number => order?.remittanceManualAdjustmentTotalAmount;

export const REMITTANCE_DEFAULT_DELIVERY_TYPES = [
  DeliveryTypeEnum.EXPRESS,
  DeliveryTypeEnum.EXPRESS_LONG_DISTANCE,
  DeliveryTypeEnum.NEXT_DAY,
  DeliveryTypeEnum.SAME_DAY
];

export function isInvalidThreeMonth(dateFrom, dateTo) {
  return (
    moment(dateFrom).isAfter(dateTo) ||
    moment(dateTo).diff(dateFrom, "days") > 90
  );
}

export const getMomentDate = (format: string, condition: number = 0) =>
  moment(new Date())
    .add(condition, "days")
    .format(format);

export const convertStringToBoolean = val => {
  if (val === "true") {
    return true;
  } else if (val === "false") {
    return false;
  } else {
    return null;
  }
};

export const openImageInNewTab = imageUrl => {
  window.open(imageUrl, "_blank");
};
